import BaseApi from "./BaseApi";

class retreatClosureApi extends BaseApi {
  async getAllRetreatClosures(data) {
    return this.API({
      url: "/closure/get-all-retreat-closures",
      data: data,
      method: "post",
    });
  }

  async sendMailToLead(data) {
    return this.API({
      url: "/closure/send-mail-to-lead",
      data: data,
      method: "post",
    });
  }

  async getMailRecipients(data) {
    return this.API({
      url: "/closure/get-mail-recipients",
      data: data,
      method: "post",
    });
  }

  
}

export default retreatClosureApi;